export default "__VITE_ASSET__8863bd20__"